import { Switch } from "antd";
import { makeVar, useReactiveVar } from "@apollo/client";
import { userUseMutation } from "../hooks/index";

const pendingUserStatuses = makeVar({});

const UserRadioField = ({ user, field = "diamond_status" }) => {
    const { _setUserCreateUpdate } = userUseMutation.createUpdate(user?.id, false);
    const userID = String(user?.id);
    const pending = !!useReactiveVar(pendingUserStatuses)[userID];

    return (
        <Switch
            checked={!!user?.[field]}
            loading={pending}
            disabled={pending}
            onChange={async (checked) => {
                if (pendingUserStatuses()[userID]) return;

                const otherField = field === "diamond_status"
                    ? "best_salesman"
                    : "diamond_status";

                pendingUserStatuses({ ...pendingUserStatuses(), [userID]: true });

                try {
                    await _setUserCreateUpdate({
                        variables: {
                            input: {
                                id: user?.id,
                                [field]: checked,
                                ...(checked ? { [otherField]: false } : {}),
                            },
                        },
                    });
                } catch {
                    // The shared mutation hook displays the error notification.
                } finally {
                    const pendingUsers = { ...pendingUserStatuses() };
                    delete pendingUsers[userID];
                    pendingUserStatuses(pendingUsers);
                }
            }}
        />
    );
};

export default UserRadioField;
